import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { getItemUrlFromSlug, getPriceResultsUrl, isPriceGuidePage } from '@/utils/urls';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { ItemSummary } from '@/types/item/ItemSummary';
import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';
import { useLocation } from 'react-router-dom';

export const TitleComponent = createInfo<ItemSummary & { position: number }>({
    className: 'line-clamp-0',
    useText: ({ itemId, position, promoted, slugWithLocation, title }) => {
        const { onNavigateInitiated } = useItemCardNavigation(itemId);
        const { pathname } = useLocation();
        const isOnPriceGuidePage = isPriceGuidePage(pathname);
        return (
            <SubtleMonochromeLink
                aria-label={title}
                className="line-clamp-2 group-[.image-hover]:text-link-hover group-[.image-hover]:underline"
                href={
                    isOnPriceGuidePage
                        ? getPriceResultsUrl(slugWithLocation)
                        : getItemUrlFromSlug(itemId, slugWithLocation)
                }
                onClick={() => {
                    onNavigateInitiated(ItemCardNavigationTrigger.TitleClick, { position, promoted });
                }}
                title={title}
            >
                {title}
            </SubtleMonochromeLink>
        );
    },
});
